var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"buttons",attrs:{"disabled":! _vm.isDirty},on:{"click":_vm.confirm}},[_vm._v("Mark items as deleted/undeleted")])])}
var staticRenderFns = []

export { render, staticRenderFns }